import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:3000/v1'}/auth`;

// Local storage keys
const TOKEN_KEY = 'auth_token';
const USER_KEY = 'auth_user';

// Authentication API functions
export const authApi = {
  // Login user
  login: async (username, password) => {
    const response = await axios.post(`${API_URL}/login`, { username, password });
    if (response.data.response ) {
      const authData = response.data.response;
      localStorage.setItem(TOKEN_KEY, authData.access_token);
      localStorage.setItem(USER_KEY, JSON.stringify(authData.user));
    }
    return response.data;
  },
  
  // Register user
  register: async (userData) => {
    return axios.post(`${API_URL}/register`, userData);
  },
  
  // Logout user
  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
};

// Helper functions
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const getUser = () => {
  const userStr = localStorage.getItem(USER_KEY);
  if (userStr) {
    return JSON.parse(userStr);
  }
  return null;
};

export const isAuthenticated = () => {
  return getToken() !== null;
};

export default authApi;
